import { render, staticRenderFns } from "./NotificationInformation.vue?vue&type=template&id=33c32531&scoped=true"
import script from "./NotificationInformation.vue?vue&type=script&lang=js"
export * from "./NotificationInformation.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NotificationInformation.vue?vue&type=style&index=1&id=33c32531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c32531",
  null
  
)

export default component.exports